import {CallForPapers, FormWidget, PaperSubmission} from "../../../types/types";

interface PresentationTypeWidgetConfig extends FormWidget {
    defaultValue: string
}

export function type() {
    return 'presentation_type';
}

/**
 * liest den Wert aus der Paper Submission aus und gibt ihn zurück
 * @param callForPapers
 * @param widget
 * @param submission
 * @returns {*}
 */
export function submissionValue(callForPapers: CallForPapers, widget: FormWidget, submission: PaperSubmission) {
    return submission?.pcoPlus?.presentationType
}

export function initialValue(widget: PresentationTypeWidgetConfig) {
    return widget.defaultValue
}

export {schema, component} from '../SingleChoiceWidget'